module.exports = __webpack_public_path__ + "static/media/AttachmentIcon.095ac384.svg";